
import XNumber from 'vux/src/components/x-number/index.vue'

import noData from '@/common/components/noData/index.vue'
import GHeader from '@/common/components/g-header/index.vue'
import GDialog from '@/common/components/g-dialog/index.vue'
import { getYEBList, buyYEB } from '@/common/api/YuEBao.js'
import loadmorelistMx from '@/common/mixin/loadmorelist.js'
import loadMore from '@/common/components/load-more/index.vue'
export default {
inject: ['parentCom'],
components: { loadMore,noData,GHeader,GDialog,XNumber },
mixins: [loadmorelistMx(getYEBList, true, { pageSize: 10 })],
data() {
return {
buyShow: false,
productInfo: null,
buyParams: {}
}
},
created() {

},
methods: {
handleBuy({ bonusId, bonusName, buyMinAmount, buyMaxAmount, totalRate}) {
this.productInfo = {
bonusId,
name: bonusName,
min: buyMinAmount,
max: buyMaxAmount,
totalRate,
val: Math.ceil(buyMinAmount),

}
this.buyShow = true
},

handleSubmit(v) {
if (!v) {
this.resetBuyInfo()
} else { // 表示要购买
if(this.productInfo.val<this.productInfo.min) return this.$vux.toast.show({ text: this.$t('mine.yuerbao.minamount'), type: 'cancel' })
const { val, bonusId } = this.productInfo
if (val > this.$store.state.userInfo.assetsInfoMap.availBalance) {
this.$vux.toast.show({ text: this.$t('mine.yuerbao.noeng'), type: 'cancel' })
return
}
const params = { UUID: this.$store.state.UUID, amount: val, bonusId }
buyYEB(params).then(([data, err]) => {
if (!err) {
this.$vux.toast.show({ text: `${this.$t('mine.yuerbao.gx')} ${this.productInfo.name} ${this.$t('mine.yuerbao.Success')}`, type: 'success' })
this.pages.pageNo = 1
this.handleFetch()
} else {
this.$vux.toast.show({ text: err.message, type: 'warn' })
}
this.resetBuyInfo()
})
}
},

resetBuyInfo() { // 重置购买信息
this.buyShow = false
this.productInfo = null
},

getparams() { // 获取参数
return this.$Cookies.get('UUID') ? { UUID: this.$Cookies.get('UUID') } : {}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/yu-e-bao/product/index.vue